import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { inputInjectionKey as m } from "./interface.js";
import { len as s } from "./utils.js";
import { resolveSlotWithTypedProps as i } from "../../_utils/vue/resolve-slot.js";
import { defineComponent as p, inject as d, computed as f, h as c } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const x = p({
  name: "InputWordCount",
  setup(v, {
    slots: o
  }) {
    const {
      mergedValueRef: t,
      maxlengthRef: u,
      mergedClsPrefixRef: a,
      countGraphemesRef: l
    } = d(m), n = f(() => {
      const {
        value: e
      } = t;
      return e === null || Array.isArray(e) ? 0 : (l.value || s)(e);
    });
    return () => {
      const {
        value: e
      } = u, {
        value: r
      } = t;
      return c("span", {
        class: `${a.value}-input-word-count`
      }, i(o.default, {
        value: r === null || Array.isArray(r) ? "" : r
      }, () => [e === void 0 ? n.value : `${n.value} / ${e}`]));
    };
  }
});
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/input/src/WordCount.js
// module id = 1703
// module chunks = 67